// Pure helpers for the analytics filter body — kept separate from the React
// component so the emitted-condition contract is unit-testable without a DOM.
// The analytics filter emits SegmentDefinition conditions { field, op, value }
// with op in {"in","nin"} and value = an array of raw ids/codes.

export type AnalyticsOp = "in" | "nin";

export const asArray = (v: unknown): unknown[] =>
  Array.isArray(v) ? v : v == null || v === "" ? [] : [v];

// Coerce a raw stored id (from a condition value) to the value type its option
// list uses, so selection round-trips for static-option controls. `int` ->
// number; `bool`/`text`/uuid ids stay strings (bool options are "true"/"false").
export const coerceId = (
  v: unknown,
  valueType: "int" | "bool" | "text",
): string | number => {
  if (valueType === "int") return typeof v === "number" ? v : Number(v);
  return String(v);
};

export const normalizeOp = (op: unknown): AnalyticsOp =>
  op === "nin" ? "nin" : "in";
